export default [
  { to: 'akutkompendiet', title: 'Akutkompendiet' },
  { to: 'kardiologi', title: 'Kardiologi' },
  { to: 'infektioner', title: 'Infektioner' },
  { to: 'ovrigt', title: 'Övriga sektioner' },
  { to: 'ekg', title: 'EKG-tolkning' },
];
